import bgc1 from "../../assets/bgc1.webp";
import bgc2 from "../../assets/bgc2.webp";
import bgc3 from "../../assets/bgc3.webp";

const sliderItems = [
  {
    id: 1,
    img: bgc1,
    alt: "Modern lab setup with computers and technical diagrams",
    title: "INNOVATION MEETS TECHNOLOGY",
    text: "Our engineering project merges advanced AI with computer hardware expertise, guiding you to the perfect device. Experience next-level recommendations tailor-made for your needs.",
  },
  {
    id: 2,
    img: bgc2,
    alt: "Technicians analyzing a new laptop in a professional workspace",
    title: "KNOWLEDGE IS POWER",
    text: "Harness the power of collaborative filtering, content-based systems, and fuzzy logic to explore top-tier components. We ensure each recommendation drives you closer to your perfect setup.",
  },
  {
    id: 3,
    img: bgc3,
    alt: "A research team discussing engineering solutions around a computer",
    title: "ENGINEERED FOR SUCCESS",
    text: "Our platform fuses academic research and practical insights to elevate your shopping journey. Choose from cutting-edge products with confidence, backed by expert engineering.",
  },
];

export default sliderItems;
